// @ts-nocheck
import { immerable } from "immer";
import { RangeModifier } from "../../../connections/models";
import { VendorDataCollection } from "../../../vendor-data/models";

export class LensGroupInfo {
    public [immerable] = true;
    public readonly groupId: string = null;
    public readonly vendorData = new VendorDataCollection(null);
    public readonly name: string = null;
    public readonly scheduleRange: RangeModifier = new RangeModifier();
    public readonly priority: number = 0;
    public readonly isUpdated: boolean = false;
    public readonly numberOfLenses: number = 0;
    public readonly isNew: boolean = false;
    public readonly isRemoved: boolean = false;
}
